import styled from '@emotion/styled';
import { InfoOutlined } from '@mui/icons-material';

export const VideaToothParts = () => (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_5717_13689"
      maskUnits="userSpaceOnUse"
      x="-0.383972"
      y="0"
      width="24"
      height="26"
      fill="black"
    >
      <rect fill="white" x="-0.383972" width="24" height="26" />
      <path d="M16.8509 2C13.5269 2 12.8344 3.2905 11.7957 3.2905C10.6877 3.2905 10.2722 2 7.08673 2C3.90125 2 1.61603 3.2905 1.61603 6.7933C1.61603 9.59553 3.69351 14.0652 4.73225 15.9497C4.45525 18.6331 4.53835 24 7.08673 24C10.2722 24 8.74871 15.9497 11.7957 15.9497C14.8427 15.9497 14.1502 24 16.8509 24C19.0115 24 19.2285 18.6331 19.0669 15.9497C20.0595 13.9423 22.0446 9.30056 22.0446 6.7933C22.0446 3.65922 20.1749 2 16.8509 2Z" />
    </mask>
    <path
      d="M16.8509 2C13.5269 2 12.8344 3.2905 11.7957 3.2905C10.6877 3.2905 10.2722 2 7.08673 2C3.90125 2 1.61603 3.2905 1.61603 6.7933C1.61603 9.59553 3.69351 14.0652 4.73225 15.9497C4.45525 18.6331 4.53835 24 7.08673 24C10.2722 24 8.74871 15.9497 11.7957 15.9497C14.8427 15.9497 14.1502 24 16.8509 24C19.0115 24 19.2285 18.6331 19.0669 15.9497C20.0595 13.9423 22.0446 9.30056 22.0446 6.7933C22.0446 3.65922 20.1749 2 16.8509 2Z"
      fill="#AEBEE8"
    />
    <path
      d="M19.0669 15.9497L17.6582 15.2532L17.4732 15.6275L17.4983 16.0442L19.0669 15.9497ZM4.73225 15.9497L6.29537 16.1111L6.34587 15.6219L6.10847 15.1912L4.73225 15.9497ZM11.7957 4.86193C12.3929 4.86193 12.8768 4.67123 13.2132 4.51641C13.3778 4.4407 13.549 4.35288 13.6836 4.28487C13.8293 4.21129 13.9647 4.14405 14.1101 4.07878C14.638 3.84169 15.4236 3.57143 16.8509 3.57143V0.428571C14.9543 0.428571 13.7315 0.803565 12.8226 1.21172C12.6087 1.30776 12.4206 1.40184 12.2668 1.47948C12.102 1.56271 11.9979 1.61604 11.8995 1.66131C11.7101 1.74846 11.7178 1.71907 11.7957 1.71907V4.86193ZM16.8509 3.57143C18.2711 3.57143 19.1357 3.92601 19.6344 4.38158C20.1099 4.81597 20.4732 5.54368 20.4732 6.7933H23.616C23.616 4.90884 23.0444 3.2399 21.7541 2.06116C20.4869 0.903601 18.7546 0.428571 16.8509 0.428571V3.57143ZM20.4732 6.7933C20.4732 7.74838 20.0674 9.30845 19.4493 11.0271C18.852 12.6876 18.1322 14.2947 17.6582 15.2532L20.4755 16.6462C20.9942 15.5973 21.7632 13.8798 22.4066 12.0908C23.0292 10.3599 23.616 8.34547 23.616 6.7933H20.4732ZM17.4983 16.0442C17.5749 17.3161 17.5571 19.1921 17.2835 20.7008C17.1442 21.469 16.9608 22.0112 16.778 22.3209C16.6025 22.6182 16.6107 22.4286 16.8509 22.4286V25.5714C18.1714 25.5714 19.0169 24.7109 19.4847 23.9181C19.9453 23.1377 20.2111 22.1704 20.3759 21.2615C20.7106 19.4159 20.7205 17.2668 20.6355 15.8553L17.4983 16.0442ZM16.8509 22.4286C17.141 22.4286 17.0727 22.699 16.7667 22.0618C16.4819 21.469 16.2596 20.6332 15.9699 19.5639C15.7077 18.5964 15.3822 17.4062 14.8753 16.4635C14.3633 15.5111 13.4199 14.3783 11.7957 14.3783V17.5211C11.7957 17.5211 11.7794 17.5101 11.8013 17.5275C11.8518 17.5675 11.9622 17.6822 12.1071 17.9517C12.4118 18.5184 12.6532 19.3408 12.9364 20.3858C13.192 21.3291 13.4934 22.5059 13.9336 23.4225C14.3525 24.2947 15.2104 25.5714 16.8509 25.5714V22.4286ZM11.7957 14.3783C10.1144 14.3783 9.22501 15.5826 8.78644 16.5694C8.36351 17.521 8.13802 18.7276 7.9516 19.6699C7.74183 20.7301 7.56978 21.5301 7.31428 22.0768C7.19526 22.3314 7.10624 22.4193 7.08383 22.4377C7.07779 22.4426 7.08478 22.4361 7.10106 22.4302C7.11742 22.4244 7.11707 22.4286 7.08673 22.4286V25.5714C8.76002 25.5714 9.6866 24.4236 10.1615 23.4075C10.6115 22.4447 10.8463 21.2322 11.0347 20.2799C11.2465 19.2095 11.4105 18.4036 11.6584 17.8458C11.7745 17.5845 11.8595 17.4994 11.8733 17.4875C11.8741 17.4868 11.8581 17.5 11.8282 17.5112C11.7978 17.5226 11.7821 17.5211 11.7957 17.5211V14.3783ZM7.08673 22.4286C7.06709 22.4286 7.06243 22.4262 7.06712 22.4276C7.07181 22.4289 7.07349 22.4304 7.06943 22.4279C7.05964 22.4218 7.00128 22.3819 6.91402 22.2504C6.72357 21.9635 6.5324 21.4505 6.39609 20.7003C6.12762 19.2225 6.16526 17.3716 6.29537 16.1111L3.16912 15.7884C3.02224 17.2113 2.96292 19.3855 3.30385 21.262C3.47224 22.1889 3.76235 23.1853 4.29556 23.9886C4.86276 24.843 5.78484 25.5714 7.08673 25.5714V22.4286ZM6.10847 15.1912C5.62023 14.3054 4.87324 12.7832 4.25299 11.156C3.61565 9.48385 3.18746 7.89154 3.18746 6.7933H0.0445993C0.0445993 8.49729 0.655145 10.5409 1.31623 12.2753C1.99441 14.0546 2.80552 15.7095 3.35603 16.7083L6.10847 15.1912ZM3.18746 6.7933C3.18746 5.41114 3.61806 4.7185 4.12669 4.31953C4.70544 3.86555 5.66634 3.57143 7.08673 3.57143V0.428571C5.32164 0.428571 3.54719 0.7797 2.18696 1.84667C0.756607 2.96865 0.0445993 4.67266 0.0445993 6.7933H3.18746ZM7.08673 3.57143C8.42923 3.57143 9.08784 3.83438 9.51339 4.04872C9.63773 4.11134 9.7532 4.17579 9.8884 4.25183C10.0123 4.32154 10.1764 4.41464 10.3436 4.49734C10.702 4.67465 11.1838 4.86193 11.7957 4.86193V1.71907C11.8536 1.71907 11.868 1.74505 11.7373 1.68039C11.6599 1.6421 11.574 1.59405 11.4291 1.51253C11.2954 1.43734 11.1231 1.34047 10.9271 1.24179C10.0716 0.810867 8.9297 0.428571 7.08673 0.428571V3.57143Z"
      fill="#222630"
      fillOpacity="0.2"
      mask="url(#path-1-outside-1_5717_13689)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66839 11.4056C2.66844 10.0887 2.67754 7.49542 4.23982 6.71429C6.14299 5.7627 7.46992 6.2517 8.91849 6.78552C9.86207 7.13325 10.8573 7.5 12.097 7.5C13.4652 7.5 14.2377 7.05327 14.9981 6.6136C15.9844 6.04332 16.9501 5.48491 19.1684 5.92857C20.8812 6.27114 20.8037 8.98626 20.7541 10.7226C20.7466 10.9839 20.7398 11.223 20.7398 11.4286L21.0085 11.3326C21.5907 9.67905 22.0446 7.99217 22.0446 6.7933C22.0446 3.65922 20.1749 2 16.8509 2C14.7188 2 13.6694 2.53095 12.9168 2.91172C12.4961 3.12458 12.1681 3.2905 11.7957 3.2905C11.3846 3.2905 11.0689 3.1129 10.6717 2.88946C9.9982 2.51061 9.09046 2 7.08673 2C3.90125 2 1.61603 3.2905 1.61603 6.7933C1.61603 8.10972 2.07451 9.79411 2.66839 11.4056Z"
      fill="#E8E8E8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4374 23.8497C17.3721 23.5271 17.2959 23.1852 17.2163 22.8276C16.7796 20.8664 16.2382 18.435 16.8113 16.1429C16.862 15.94 16.9161 15.7298 16.9715 15.5146C17.5401 13.3051 18.2432 10.5731 16.8113 9.85714C15.9553 9.42914 15.3324 9.70058 14.5617 10.0364C13.9175 10.3172 13.1701 10.6429 12.097 10.6429C11.0635 10.6429 10.1811 10.3408 9.38345 10.0678C8.36188 9.71808 7.47945 9.41601 6.597 9.85723C5.30671 10.5024 6.13531 12.7367 6.90805 14.8204C7.07642 15.2744 7.24214 15.7212 7.38271 16.1429C7.93938 17.8129 7.30467 21.6602 6.78835 23.9739C6.88385 23.9911 6.98327 23.9999 7.08677 23.9999C7.26736 23.9999 7.43282 23.9741 7.58483 23.9252C7.60702 23.8338 7.62954 23.7415 7.65226 23.6483C8.1848 21.4643 8.83357 18.8036 8.1684 16.1429C7.78726 14.6184 8.1684 13.7857 8.95411 13C9.22223 12.7319 9.39885 12.5553 9.60887 12.4389C10.0143 12.2143 10.5442 12.2143 12.097 12.2143H12.0978C14.4541 12.2143 14.4542 12.2143 15.2398 12.9999C16.0255 13.7857 16.4067 14.6182 16.0255 16.1429C15.3604 18.8036 16.0092 21.4645 16.5417 23.6484C16.569 23.7601 16.5959 23.8705 16.6223 23.9796C16.6957 23.993 16.7719 23.9999 16.8509 23.9999C17.065 23.9999 17.2599 23.9473 17.4374 23.8497Z"
      fill="#50669D"
    />
  </svg>
);

export const InfoOutlinedIcon = styled(InfoOutlined)`
  fill: rgba(255, 255, 255, 0.75);
`;

export const VideaInfoOutlinedIcon = styled(InfoOutlined)`
  fill: rgba(255, 255, 255, 0.75);
`;

export const FmxIcon = () => (
  <svg
    width="38.4px"
    height="19.2px"
    viewBox="0 0 48 24"
    fill="none"
    className="fmx-icon"
  >
    <rect
      x="7"
      y="2"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 7 2)"
      className="icon-shape"
    />
    <rect
      x="39"
      y="2"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 39 2)"
      className="icon-shape"
    />
    <rect
      x="14"
      y="2"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 14 2)"
      className="icon-shape"
    />
    <rect
      x="46"
      y="2"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 46 2)"
      className="icon-shape"
    />
    <rect
      x="7"
      y="9"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 7 9)"
      className="icon-shape"
    />
    <rect
      x="39"
      y="9"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 39 9)"
      className="icon-shape"
    />
    <rect
      x="14"
      y="9"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 14 9)"
      className="icon-shape"
    />
    <rect
      x="46"
      y="9"
      width="5"
      height="6"
      rx="1"
      transform="rotate(90 46 9)"
      className="icon-shape"
    />
    <rect
      x="1"
      y="21"
      width="5"
      height="6"
      rx="1"
      transform="rotate(-90 1 21)"
      className="icon-shape"
    />
    <rect
      x="33"
      y="21"
      width="5"
      height="6"
      rx="1"
      transform="rotate(-90 33 21)"
      className="icon-shape"
    />
    <rect
      x="8"
      y="21"
      width="5"
      height="6"
      rx="1"
      transform="rotate(-90 8 21)"
      className="icon-shape"
    />
    <rect
      x="40"
      y="21"
      width="5"
      height="6"
      rx="1"
      transform="rotate(-90 40 21)"
      className="icon-shape"
    />
    <rect
      x="15"
      y="21"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 15 21)"
      className="icon-shape"
    />
    <rect
      x="15"
      y="8"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 15 8)"
      className="icon-shape"
    />
    <rect
      x="21"
      y="21"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 21 21)"
      className="icon-shape"
    />
    <rect
      x="21"
      y="8"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 21 8)"
      className="icon-shape"
    />
    <rect
      x="27"
      y="21"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 27 21)"
      className="icon-shape"
    />
    <rect
      x="27"
      y="8"
      width="6"
      height="5"
      rx="1"
      transform="rotate(-90 27 8)"
      className="icon-shape"
    />
  </svg>
);

export const IOCameraWandIcon = () => (
  <svg
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
    className="io-camera-wand-icon"
  >
    <path
      d="M14.9048 4.28313L14.7654 4.1377C15.5815 3.35535 16.3497 2.62619 16.93 2.0816C17.2201 1.80937 17.4636 1.58289 17.6429 1.41881C17.7324 1.33685 17.8065 1.26991 17.8626 1.22043C17.9139 1.17523 17.961 1.13477 17.9898 1.11519V1.11519C18.3948 0.839752 18.9521 0.870233 19.3255 1.18781C19.7805 1.57478 19.7408 2.29323 19.3928 2.90321C19.3928 2.90322 19.3927 2.90323 19.3927 2.90323L19.2178 2.80339C19.0899 3.02758 17.9246 4.50927 16.6282 6.09596L16.7842 6.22343C15.6748 7.58115 15.0881 8.30551 14.7595 8.76019C14.438 9.20501 14.3762 9.3741 14.3109 9.62337C14.3109 9.62337 14.3109 9.62338 14.3109 9.62338L14.116 9.57229C13.9378 10.2521 13.4556 11.3368 12.8752 12.3637L14.9048 4.28313ZM14.9048 4.28313L14.7654 4.1377C13.7812 5.08119 13.0187 5.79598 12.4805 6.27993C12.2111 6.52215 11.9998 6.70481 11.846 6.82892C11.7688 6.89116 11.7085 6.93667 11.6641 6.96706C11.6271 6.9923 11.6115 6.99964 11.6112 7.00034C11.3443 7.06838 10.8918 7.27752 10.4123 7.53359C9.92113 7.79595 9.37943 8.11972 8.93687 8.42545L8.93686 8.42546C8.28753 8.87408 7.65417 9.46755 6.4561 10.7389C5.13899 12.1366 4.46325 12.8545 4.11982 13.2973C3.9467 13.5205 3.84516 13.6895 3.79122 13.8528C3.73653 14.0185 3.73642 14.1635 3.73642 14.3126C3.73642 14.846 3.90375 15.2499 4.31482 15.7926L4.45345 15.9756L4.27708 16.1935C4.21334 16.2722 4.04434 16.4359 3.81126 16.6427C3.58275 16.8455 3.30443 17.0794 3.03211 17.295C2.07038 18.0563 1.48962 18.555 1.15421 18.9991C0.803266 19.4639 0.721188 19.8678 0.722926 20.4103C0.725515 21.2169 1.09164 22.385 1.68617 23.5541L1.68618 23.5541C1.90762 23.9894 2.06748 24.2753 2.22771 24.4483C2.31256 24.54 2.40324 24.6069 2.50943 24.6484C2.61387 24.6893 2.71955 24.7001 2.82483 24.7001C3.0474 24.7001 3.24739 24.6569 3.41671 24.5512C3.58749 24.4446 3.70823 24.2862 3.79188 24.0895L3.79189 24.0895C3.85287 23.946 3.89142 23.8189 3.86914 23.6439C3.84958 23.4904 3.78317 23.3061 3.68 23.0406L3.67999 23.0405C3.36768 22.2369 3.16916 21.6111 3.07576 21.1394C2.98 20.6559 3.00465 20.3797 3.08108 20.2386L3.0811 20.2385C3.08091 20.2389 3.08125 20.2384 3.08225 20.2371C3.08671 20.2314 3.1043 20.2086 3.14671 20.1639C3.19301 20.1151 3.25687 20.0525 3.33641 19.978C3.49516 19.8293 3.71008 19.639 3.95793 19.427C4.45346 19.0034 5.0751 18.4983 5.63111 18.0756L5.50918 17.9152L5.63112 18.0755L6.32346 17.5491L6.62446 17.6388C6.93347 17.7309 7.28089 17.7686 7.60491 17.7565C7.92627 17.7445 8.24236 17.6829 8.48122 17.5618L14.9048 4.28313ZM11.7397 12.489C11.2852 12.3801 10.4896 11.844 10.0299 11.3367C9.66012 10.9288 8.91064 9.72404 8.91064 9.53769C8.91064 9.44985 10.6977 8.34679 11.2348 8.10312M11.7397 12.489C11.9735 12.545 12.0158 12.4991 12.4411 11.7292C13.4416 9.91781 13.824 8.34095 13.3674 7.90954M11.7397 12.489L11.7866 12.2931C11.824 12.3021 11.8408 12.3039 11.8471 12.3043C11.8512 12.3012 11.8589 12.2948 11.8705 12.2822C11.9024 12.2477 11.9461 12.1864 12.0125 12.0765C12.0776 11.9686 12.1582 11.8247 12.2648 11.6318C12.7593 10.7364 13.0968 9.90641 13.2549 9.2544C13.3341 8.92775 13.3661 8.65456 13.3548 8.44445C13.3433 8.2297 13.2885 8.11224 13.229 8.056M11.7397 12.489L11.7866 12.2931C11.5948 12.2471 11.3063 12.1021 10.9993 11.8952C10.6964 11.691 10.3958 11.4405 10.1792 11.2014L10.1792 11.2014C10.0071 11.0116 9.7352 10.6215 9.50266 10.2477C9.38746 10.0625 9.28501 9.8863 9.21208 9.74673C9.18169 9.68858 9.1575 9.63881 9.13989 9.59864M13.3674 7.90954C13.2641 7.81205 13.0742 7.71085 12.9451 7.68479C12.6345 7.6219 11.8992 7.80175 11.2348 8.10312M13.3674 7.90954L13.229 8.05598C13.229 8.05599 13.229 8.05599 13.229 8.056M13.3674 7.90954L13.229 8.056M11.2348 8.10312L11.318 8.28659M11.2348 8.10312L11.318 8.28658C11.318 8.28659 11.318 8.28659 11.318 8.28659M11.318 8.28659C11.0629 8.40235 10.4923 8.73229 9.97714 9.05028C9.72149 9.20807 9.48406 9.3601 9.31151 9.47737C9.24091 9.52536 9.18303 9.56627 9.13989 9.59864M11.318 8.28659C11.6394 8.1408 11.9775 8.02471 12.2705 7.95305C12.5737 7.87889 12.7971 7.86037 12.9052 7.88225L12.9052 7.88226C12.9439 7.89007 13.0045 7.9127 13.0712 7.94821L13.229 8.056M9.13989 9.59864C9.13627 9.59039 9.13294 9.58255 9.12988 9.57512C9.12088 9.55325 9.11547 9.53772 9.11257 9.52779C9.11107 9.52264 9.11069 9.52049 9.11078 9.52084C9.11091 9.52137 9.1121 9.52757 9.1121 9.53769C9.1121 9.57664 9.10046 9.60515 9.09478 9.61743C9.08834 9.63136 9.08175 9.64086 9.0787 9.64506C9.07469 9.65056 9.07166 9.65385 9.07098 9.65456C9.07064 9.65491 9.07089 9.65461 9.07189 9.65363C9.07712 9.6485 9.08969 9.63743 9.1126 9.61951C9.12091 9.61301 9.13001 9.60605 9.13989 9.59864ZM14.1734 7.46656L14.1733 7.46651C14.0304 7.24833 13.7702 7.03715 13.5318 6.95183L13.5317 6.95179C13.5056 6.94249 13.4811 6.93297 13.4584 6.92351C13.4666 6.91516 13.4752 6.90651 13.4841 6.89756C13.5961 6.7846 13.7546 6.62882 13.9448 6.44423C14.325 6.07529 14.8289 5.59405 15.3343 5.11622C15.8396 4.63838 16.3458 4.16456 16.7303 3.81044C16.9228 3.63324 17.084 3.48675 17.1991 3.38489C17.2235 3.36333 17.2456 3.34401 17.2652 3.32697C17.3001 3.3649 17.3394 3.41274 17.3773 3.46542C17.3774 3.46544 17.3774 3.46546 17.3774 3.46548L17.4861 3.61648L15.8657 5.6267C15.8657 5.6267 15.8657 5.6267 15.8657 5.6267C15.3939 6.21197 14.9599 6.74432 14.6408 7.13045C14.4812 7.32363 14.3509 7.47961 14.2591 7.58716C14.2586 7.58772 14.2582 7.58829 14.2577 7.58885C14.2311 7.5523 14.2024 7.51087 14.1734 7.46656ZM11.8432 12.3066C11.8432 12.3066 11.8437 12.3063 11.8447 12.3059L11.8432 12.3066ZM10.8935 13.0931L10.8935 13.0931L11.1389 13.2149L9.69959 14.8014C9.25606 15.2903 8.82772 15.7437 8.49532 16.0802C8.32892 16.2486 8.18789 16.3864 8.08169 16.4842C8.02838 16.5333 7.98574 16.5705 7.95411 16.596C7.9383 16.6088 7.92713 16.6171 7.92001 16.6219C7.33989 16.8345 6.69295 16.6217 5.77619 15.7407C5.46613 15.4427 5.21612 15.1472 5.04525 14.8878C4.86854 14.6195 4.79612 14.4191 4.79612 14.304C4.79612 14.3048 4.79619 14.3046 4.79658 14.3032C4.79873 14.2952 4.8108 14.2506 4.87704 14.1477C4.94896 14.036 5.06645 13.8822 5.24511 13.6707C5.60164 13.2486 6.18368 12.6174 7.0842 11.6682L8.32505 10.3603L8.47347 10.6479C8.6332 10.9577 8.94125 11.4249 9.16399 11.6954C9.66364 12.3024 10.2372 12.767 10.8935 13.0931ZM7.91489 16.6252C7.91495 16.6252 7.91525 16.625 7.91578 16.6247L7.91489 16.6252ZM7.93071 16.618L7.93068 16.618L7.93071 16.618ZM5.346 16.8535L5.34601 16.8535C5.35652 16.865 5.3658 16.8752 5.37411 16.8845C5.33961 16.9126 5.29255 16.9481 5.22713 16.9973L5.22711 16.9973C4.37146 17.6398 3.62552 18.2398 3.07427 18.7233C2.79888 18.9649 2.5699 19.1793 2.39945 19.3566C2.31429 19.4452 2.24183 19.5265 2.18487 19.5989C2.13001 19.6685 2.0812 19.7401 2.0527 19.8081C1.89311 20.189 1.89708 20.7313 2.0195 21.3815C2.04154 21.4987 2.06764 21.6203 2.09775 21.7463C2.07122 21.6754 2.04672 21.607 2.02471 21.5421L1.83393 21.6069L2.0247 21.5421C1.76613 20.7805 1.71132 20.3563 1.89515 19.9485C1.99016 19.7377 2.15536 19.5173 2.42042 19.254C2.68553 18.9906 3.04152 18.6929 3.50906 18.3252C3.85708 18.0514 4.20332 17.7652 4.48127 17.5243C4.75255 17.2891 4.97514 17.0831 5.06107 16.9755L5.06108 16.9755C5.13809 16.879 5.19168 16.8152 5.23347 16.7737C5.24025 16.7669 5.2462 16.7613 5.25134 16.7567C5.2727 16.7755 5.3024 16.8056 5.346 16.8535ZM5.49492 16.7178C5.67234 16.9125 5.67131 16.9157 5.34808 17.1584L4.90363 16.8498C5.2095 16.4666 5.25651 16.4561 5.49492 16.7178ZM18.5448 2.07758C18.5381 2.09905 18.5293 2.1238 18.5186 2.15145C18.4875 2.23172 18.4436 2.32697 18.3945 2.42116C18.3454 2.51542 18.2932 2.60456 18.2468 2.67325C18.2342 2.69179 18.2226 2.70811 18.212 2.72216C18.1942 2.70813 18.1738 2.68968 18.1522 2.66681C18.1133 2.62569 18.0786 2.57866 18.0548 2.53499C18.0443 2.51574 18.0369 2.49895 18.0321 2.4852C18.044 2.47 18.0614 2.45026 18.0849 2.42644C18.1468 2.36384 18.2344 2.28982 18.3286 2.22027C18.4046 2.16411 18.4803 2.11428 18.5448 2.07758ZM18.015 2.51031C18.0149 2.51034 18.0154 2.50918 18.0169 2.50674C18.0159 2.50906 18.0151 2.51027 18.015 2.51031Z"
      fill="white"
      stroke="white"
      strokeWidth="0.402927"
    />
  </svg>
);

export const RefreshImageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5714 15.51L8.25 12.5L5 17H18L13.8214 11L10.5714 15.51Z"
      fill="#FF8A1E"
    />
    <path
      d="M14.2394 3.3L13 2V6H16.8136L15.2881 4.4C15.839 3.27778 16.9619 2.5 18.2436 2.5C20.0869 2.5 21.5805 4.06667 21.5805 6C21.5805 7.93333 20.0869 9.5 18.2436 9.5C17.1102 9.5 16.1038 8.9 15.5106 8H13.8686C14.5996 9.75556 16.2839 11 18.2331 11C20.8602 11 23 8.75556 23 6C23 3.24445 20.8602 1 18.2331 1C16.5487 1 15.0869 1.92222 14.2394 3.3Z"
      fill="#FF8A1E"
    />
    <path
      d="M19.5 12V19H2.98V5H11.5V3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5Z"
      fill="#FF8A1E"
    />
  </svg>
);

export const SideBySideIcon = () => (
  <svg>
    <path
      d="M33.3333 31.1111V32.2222C33.3333 34.0632 31.841 35.5556 30 35.5556H3.33333C1.49236 35.5556 0 34.0632 0 32.2222V14.4445C0 12.6035 1.49236 11.1111 3.33333 11.1111H4.44444V25.5556C4.44444 28.6189 6.93667 31.1111 10 31.1111H33.3333ZM40 25.5556V7.77779C40 5.93682 38.5076 4.44446 36.6667 4.44446H10C8.15903 4.44446 6.66667 5.93682 6.66667 7.77779V25.5556C6.66667 27.3965 8.15903 28.8889 10 28.8889H36.6667C38.5076 28.8889 40 27.3965 40 25.5556ZM17.7778 11.1111C17.7778 12.9521 16.2854 14.4445 14.4444 14.4445C12.6035 14.4445 11.1111 12.9521 11.1111 11.1111C11.1111 9.27015 12.6035 7.77779 14.4444 7.77779C16.2854 7.77779 17.7778 9.27015 17.7778 11.1111ZM11.1111 21.1111L14.9663 17.2559C15.2917 16.9305 15.8194 16.9305 16.1449 17.2559L18.8889 20L28.2997 10.5892C28.6251 10.2638 29.1527 10.2638 29.4782 10.5892L35.5556 16.6667V24.4445H11.1111V21.1111Z"
      fill="#ADB9DB"
    />
  </svg>
);
